import { render } from "./DocumentiFiscali.vue?vue&type=template&id=0ccdb4e8&scoped=true"
import script from "./DocumentiFiscali.vue?vue&type=script&lang=js"
export * from "./DocumentiFiscali.vue?vue&type=script&lang=js"

import "./DocumentiFiscali.vue?vue&type=style&index=0&id=0ccdb4e8&scoped=true&lang=css"

import exportComponent from "/root/frontTioPizza/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccdb4e8"]])

export default __exports__